import { useState, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { toast } from "react-toastify";

const useMedia = () => {
  const { baseUrl, userID, basicAuth } = useContext(GlobalContext);

  const [mediaList, setMediaList] = useState([]);
  const [loadingMedia, setLoadingMedia] = useState(false);

  const fetchUploadedMedia = async () => {
    setLoadingMedia(true);
    try {
      const res = await fetch(`${baseUrl}/Whatsapp/getUploadedMedia`, {
        method: "POST",
        headers: {
          Authorization: basicAuth,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userid: userID,
          offset: "100",
          page: "1",
        }),
      });
      const data = await res.json();
      if (data.responseCode === "00") {
        setMediaList(data.data || []);
      } else {
        toast.error(data.responseMessage || "Failed to load media");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setLoadingMedia(false);
    }
  };

  const sendMedia = async (payload) => {
    try {
      const res = await fetch(`${baseUrl}/Whatsapp/sendMedia`, {
        method: "POST",
        headers: {
          Authorization: basicAuth,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userid: userID,
          ...payload,
        }),
      });

      const data = await res.json();

      if (data.responseCode === "00") {
        toast.success(data.responseMessage || "Media sent successfully");
      } else {
        toast.error(data.responseMessage || "Failed to send media");
      }

      return data;
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    }
  };

  return {
    mediaList,
    loadingMedia,
    fetchUploadedMedia,
    sendMedia,
  };
};

export default useMedia;